export default import.meta.ROLLDOWN_FILE_URL_mqdN$Z33bK5c4V5ju81OPQ